<template>
    <div>
        <hero-banner
            :header="dataHeroBanner.header"
            :image="dataHeroBanner.image"
            :subline="dataHeroBanner.subline"
            :border-bottom="true"
            reverse-img
            disruptor-svg=""
            dark
        >
            <template #cta>
                <div class="cta__container">
                    <a
                        href="#partnersFooter"
                        class="cta"
                        @click="handleCtaClick"
                    >
                        <SVGIcon icon-name="arrow-right" class="cta__icon" />
                        <span>{{ dataHeroBanner.cta }}</span>
                    </a>
                </div>
            </template>
        </hero-banner>
        <div class="partners">
            <section class="section--slim">
                <v-container class="container--slim">
                    <h2 class="partners__title">
                        {{ partners.title }}
                    </h2>
                    <p
                        class="partners__description"
                        v-html="partners.description"
                    />
                </v-container>
            </section>
            <div class="partners__cards">
                <partner-card
                    v-for="({ partnerName, image, description, href },
                    index) in partners.items"
                    :key="index"
                    class="partners__card"
                    :image="image"
                    :partner-name="partnerName"
                    :description="description"
                    :href="href"
                />
            </div>
            <section
                id="partnersFooter"
                class="partnersFooter section--slate050"
            >
                <v-container class="container--slim">
                    <h2 class="partnersFooter__title">
                        {{ footer.title }}
                    </h2>
                    <p class="partnersFooter__description">
                        {{ footer.description }}
                    </p>
                    <div class="footerLinks">
                        <div>
                            <div class="footerLink__container">
                                <SVGIcon
                                    icon-name="cs_email-action-ad"
                                    class="footerLink__svg"
                                />
                                <a
                                    class="footerLink__link"
                                    :href="`mailto:${footer.email}`"
                                    >{{ footer.email }}</a
                                >
                            </div>
                        </div>
                    </div>
                </v-container>
            </section>
        </div>
    </div>
</template>

<script>
import HeroBanner from '@/components/organisms/heroBanner/wide.vue'
import SVGIcon from '@/components/atoms/icons/SVGIcon.vue'
import PartnerCard from '@/components/molecules/card/partnerCard.vue'
import gtmTracking from '@/mixins/gtmTracking'

export default {
    name: 'Partner',
    path: 'partner',
    layout: 'native',
    components: {
        HeroBanner,
        SVGIcon,
        PartnerCard,
    },
    mixins: [gtmTracking],
    data() {
        return {
            dataHeroBanner: {
                header: 'Careship Partnerschaften',
                image: 'heroBanner/shutterstock_792589495',
                subline: 'Gemeinsam für eine starke Unterstützung im Alltag',
                cta: 'Partner werden',
            },
            partners: {
                title: 'Unsere Partner',
                description:
                    'Careship arbeitet mit anderen Unternehmen und Institutionen aus dem Gesundheitsbereich zusammen. Die entstehenden Synergien tragen dazu bei, das Angebot für Unterstützung im Alltag kontinuierlich zu verbessern und mehr Menschen, die darauf angewiesen sind, schneller zu erreichen.  Die Art der Zusammenarbeit ist so unterschiedlich wie unsere Partner. Sie alle haben eines gemeinsam – sie helfen Menschen mit Unterstützungsbedarf direkt oder indirekt dabei, den Alltag zu bewältigen.<br/><br/>Wir freuen uns auf spannende neue Partnerschaften sowie im Netzwerk gemeinsam zu wachsen und Neues zu schaffen!',
                items: [
                    {
                        partnerName: 'Verbund Pflegehilfe',
                        description:
                            'Der Verbund Pflegehilfe berät Pflegebedürftige und Angehörige kostenlos zu pflegerelevanten Themen und vermittelt Pflege-Anbieter in der DACH-Region',
                        image: 'partners/logo_verbund-pflegehilfe.png',
                        href: 'https://www.pflegehilfe.org/',
                    },
                    {
                        partnerName: 'Pflege.de',
                        description:
                            'Service-Partner für Pflegebedürftige und Familien, deren Pflegealltag zuhause durch gezielte Angebote, Informationen und Austausch erleichtert wird',
                        image: 'partners/logo_pflege-de.png',
                        href: 'https://www.pflege.de/',
                    },
                    {
                        partnerName: 'Wohnen im Alter',
                        description:
                            'Der Rundum-Überblick für Pflegebedürftige, Senioren und Angehörige: Vermittlung von Pflegeplätze und Dienstleistungen sowie informativer Ratgeber.',
                        image: 'partners/logo_wohnen-im-alter.png',
                        href: 'https://www.wohnen-im-alter.de/',
                    },
                    {
                        partnerName: 'Nui',
                        description:
                            'Ein intelligenter, digitaler Assistent für pflegende Angehörige, der durch Information die häusliche Pflege und Organisation der Pflege unterstützt.',
                        image: 'partners/logo_nui.png',
                        href: 'https://www.nui.care/',
                    },
                    {
                        partnerName: 'edith.care',
                        description:
                            'edith.care ist ein digitales Pflegeökosystem zur Entlastung von Pflegebedürftigen, Angehörigen, Leistungserbringern und Pflegekassen.',
                        image: 'partners/logo_edith-care.png',
                        href: 'https://www.edith.care/',
                    },
                    {
                        partnerName: 'Deutscher Pflegering',
                        description:
                            'Zur besseren Vereinbarkeit von Beruf und Familie bietet der Deutsche Pflegering eine bundesweite Hilfe für Beschäftigte in allen Lebenslagen.',
                        image: 'partners/logo_deutscher-pflegering.png',
                        href: 'https://www.pflegering.de/',
                    },
                    {
                        partnerName: 'proSenio',
                        description:
                            'Die proSenio PflegeBox erleichtert Ihren Pflegealltag. Jederzeit mit Pflegehilfsmitteln rundum versorgt sein – zuverlässig und zuzahlungsfrei.',
                        image: 'partners/logo_prosenio.png',
                        href:
                            'https://pflegebox.de/gesundheitundpflege/?utm_source=careship&utm_medium=kooperationen&utm_term=landingpage&utm_content=partnerseite&utm_campaign=careship_koop',
                    },
                    {
                        partnerName: 'InsurLab',
                        description:
                            'Das InsurLab Germany zielt als eines von 12 Innovation Hubs in Deutschland darauf ab, die Transformation der Versicherungsbranche voranzutreiben.',
                        image: 'partners/logo_insurlab.png',
                        href: 'https://insurlab-germany.com/',
                    },
                    {
                        partnerName: 'Pflegehilfe für Senioren',
                        description:
                            'Die Pflegehilfe für Senioren ermöglicht mit Ihrer 24-Stunden-Pflege einen geborgenen und umsorgten Lebensabend in den eigenen vier Wänden',
                        image: 'partners/logo_pflegehilfe-fuer-senioren.png',
                        href: 'https://www.pflegehilfe-senioren.de/',
                    },
                    {
                        partnerName: 'DeinePflege.de',
                        description:
                            'Der persönliche, digitale Pflegebegleiter. – DeinePflege hilft Pflegepatienten und Angehörigen, ihre Pflege einfach und transparent zu organisieren.',
                        image: 'partners/logo_deine-pflege.png',
                        href: 'https://www.deinepflege.de',
                    },
                    {
                        partnerName: 'Mobilae',
                        description:
                            'Mobilae trägt zu einer Welt bei, in der Senioren das Leben führen können, das sie sich vorstellen - mobil, sicher und unabhängig.',
                        image: 'partners/logo_mobilae.png',
                        href: 'https://www.mobilae.de/',
                    },
                    {
                        partnerName: 'Seniovo',
                        description:
                            'Pflegegerechte Bäder ohne Zuzahlung mit Pflegekassen-Zuschuss inklusive Übernahme der Antragstellung & Einholen der Vermietergenehmigung.',
                        image: 'partners/logo_seniovo.png',
                        href: 'https://www.seniovo.de/',
                    },
                    {
                        partnerName: 'Livy',
                        description:
                            'Livy Alive ist eine innovative Smart Living Station zur Erkennung von zahlreichen Gefahren im Haushalt mit integrierter Video- und Audiosprechanlage.',
                        image: 'partners/logo_livy.png',
                        href: 'https://livy-home.com/',
                    },
                ],
            },
            footer: {
                title: 'Interesse an einer Partnerschaft?',
                description:
                    'Schreiben Sie uns ganz unkompliziert ein E-Mail oder rufen Sie uns an.',
                email: 'kooperation@careship.de',
            },
        }
    },
    methods: {
        handleCtaClick(e) {
            e.preventDefault()

            this.trackEvent({
                category: 'partners page',
                action: 'user clicked on cta',
                label: this.dataHeroBanner.cta,
            })

            this.$vuetify.goTo('#partnersFooter', {
                duration: 500,
                offset: 30,
                easing: 'easeInOutCubic',
            })
        },
    },
    head() {
        return {
            title: 'Partner | Careship',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content:
                        'Careship arbeitet mit namhaften Unternehmen & Institutionen aus dem Gesundheitsbereich zusammen. Hier finden Sie eine Übersicht unserer Kooperationspartner.',
                },
            ],
        }
    },
}
</script>

<style lang="stylus" scoped>
.cta {
    display: flex;
    align-items: center;
    text-decoration: none;
    font-size: 20px;
    height: 32px;
    font-weight: 700;
    position: relative;

    &:after {
        background: $cs-primary;
        bottom: 0;
        content: '';
        height: 2px;
        left: 0;
        position: absolute;
        right: 100%;
        transition: right .2s;
    }

    &:hover:after {
        right: 0;
    }
}

.cta__container {
    display: inline-block;
    margin-top: $cs-space;
}

.cta__icon {
    height: 32px;
    width: 32px;
    margin-right: $cs-spaces.half;
}

.partners {
    padding-top: $cs-spaces.triple;
    text-align: center;

    @media $display-breakpoints.md-and-up {
        padding-top: 56px;
    }
}

.partners__title {
    margin-bottom: $cs-spaces.half;
}

.partners__description {
    margin-bottom: $cs-spaces.onehalf;
}

.partners__cards {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 1264px;
    margin: auto;
}

.partners__card {
    margin: $cs-space;
    max-width: 332px;

    @media $display-breakpoints.md-and-up {
        margin: $cs-spaces.onehalf;
    }
}

.partnersFooter {
    margin-top: $cs-spaces.double;
}

.partnersFooter__title {
    margin-bottom: $cs-spaces.half;
    font-size: 24px;

    @media $display-breakpoints.md-and-up {
        font-size: 28px;
    }
}

.partnersFooter__description {
    margin-bottom: $cs-spaces.double;
    font-size: 20px;

    @media $display-breakpoints.md-and-up {
        font-size: 24px;
    }
}

.footerLinks {
    display: flex;
    justify-content: center;
    align-items: center;
}

.footerLink__container {
    display: flex;
    align-items: center;
    margin-bottom: $cs-space;

    &:last-child {
        margin-bottom: 0;
    }
}

.footerLink__svg {
    height: 32px;
    width: 32px;
    margin-right: $cs-space;
    color: $cs-primary;
}

.footerLink__link {
    text-decoration: none;
    font-weight: 700;
}
</style>
